import React, { useRef, useState } from 'react';
import {
  LeftSwipperArrows,
  RightSwipperArrows
} from '../../../../shared-components/SwipperArrows/SwipperArrows';

import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore, { Navigation } from 'swiper';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import { styled } from 'styled-components';
import LandingPageTourCard from '../../../Tours/LandingPageTourCard';
import { TourCardType } from '../../../../types/pages/landing-page';
SwiperCore.use([Navigation]);

const StyledSwipper = styled(Swiper)`
  margin: 0px !important;
  .swiper-slide {
    width: 350px;
    justify-content: center;
    display: flex;
  }
`;

interface BlogTopToursProps {
  relatedProducts: TourCardType[];
}

export default function BlogTopTours({ relatedProducts }: BlogTopToursProps) {
  const [isLastSlide, setIsLastSlide] = useState(false);
  const [isFirstSlide, setIsFirstSlide] = useState(false);

  const prevRef = useRef<HTMLDivElement>(null);
  const nextRef = useRef<HTMLDivElement>(null);

  const handleSlideChange = (swiper: any) => {
    setIsLastSlide(swiper.isEnd);
    setIsFirstSlide(swiper.isBeginning);
  };

  const handleSwiperInit = (swiper: any) => {
    swiper.params.navigation.prevEl = prevRef.current;
    swiper.params.navigation.nextEl = nextRef.current;
    swiper.navigation.init();
    swiper.navigation.update();

    setIsFirstSlide(swiper.isBeginning);
    setIsLastSlide(swiper.isEnd);
  };

  return (
    <div className="w-full mb-32">
      <div className="w-[90%] md:w-[85%] lg:w-[88%] xl:w-[85%] 2xl:w-[80%] 3xl:w-[85%] 4xl:w-[85%] mx-auto flex flex-col gap-10 pb-12">
        <div className="flex justify-between items-center">
          <h2 className="text-black2 text-xl sm:text-[22px] md:text-[26px] 2xl:text-3xl font-semibold tracking-[0.4px] pr-2">
            Related Tours
          </h2>
          <div className="flex">
            <div className="flex gap-2">
              <div ref={prevRef} className="prev">
                <LeftSwipperArrows isFirstSlide={isFirstSlide} />
              </div>
              <div ref={nextRef} className="next">
                <RightSwipperArrows isLastSlide={isLastSlide} />
              </div>
            </div>
          </div>
        </div>
        <StyledSwipper
          slidesPerView={5}
          spaceBetween={20}
          grabCursor
          onSlideChange={handleSlideChange}
          onInit={handleSwiperInit}
          navigation={{ prevEl: prevRef.current, nextEl: nextRef.current }}
          breakpoints={{
            320: { slidesPerView: 1 },
            425: { slidesPerView: 1.2 },
            540: { slidesPerView: 1.5, spaceBetween: 15 },
            640: { slidesPerView: 2, spaceBetween: 15 },
            768: { slidesPerView: 2, spaceBetween: 15 },
            940: { slidesPerView: 2.5 },
            1024: { slidesPerView: 2.5 },
            1280: { slidesPerView: 3.3 },
            1330: { slidesPerView: 3.5 },
            1440: { slidesPerView: 3.5 },
            1536: { slidesPerView: 3.5 },
            1700: { slidesPerView: 3.5 },
            1800: { slidesPerView: 4 },
            1920: { slidesPerView: 4.5, spaceBetween: 20 },
            2200: { slidesPerView: 5 }
          }}
        >
          {relatedProducts?.map(
            (tour, index) =>
              tour?.carousel &&
              tour?.carousel?.length > 0 && (
                <SwiperSlide key={index}>
                  <LandingPageTourCard
                    tourCard={tour}
                    key={tour.id}
                    index={index + 1}
                  />
                </SwiperSlide>
              )
          )}
        </StyledSwipper>
      </div>
    </div>
  );
}
